import { createContext } from "react";
import { EligibleDependentContextProps } from "../../types/contexts/eligibleDependentContext/eligibleDependentContextProps.types";

const EligibleDependentContext = createContext({} as EligibleDependentContextProps);

export default EligibleDependentContext;
